import { getters } from '/@/modules/core/app/helpers/store';
import { CurrentEstateRouteConfig } from '/@/modules/core/app/helpers/CurrentEstateRouteConfig';

export class TaxesRouteConfig extends CurrentEstateRouteConfig {
  /**
   * @returns {boolean}
   */
  canAccessRoute() {
    const authUser = getters.auth.getUser();

    if (authUser.currentEstate?.isStandardPlan) {
      return false;
    }

    if (authUser.currentEstate?.isClearVault) {
      return authUser.permission.canViewIgTaxTab;
    }

    return authUser.permission.canAccessTaxes;
  }
}
